<script lang="ts" setup>
defineProps({
	item: {
		type: Object,
		required: true
	}
});
</script>

<template>
  <SearchFieldMultiMetro
    v-if="item.type === 'metro'"
    :item="item"
  />
  <SearchFieldMultiAirport
    v-else
    :item="item"
    :parent="null"
  />
</template>
